export default __webpack_public_path__ + "static/media/stamp.eb6a90cc.png";